const arrayToDropdownValues = (arr) => {
  if (!arr || !arr.length) {
    return [];
  }

  return arr.map((item) => ({ value: item, label: item }));
};

export default arrayToDropdownValues;
